import { Command, HttpVerbType, API_PREFIX, API_VERSION } from "../Command";
import { GetCurrentUserResData } from "./GetCurrentUserResData";

const ENDPOINT = "/auth/current";

export class GetCurrentUserCommand extends Command {
    endPoint: string = API_PREFIX + API_VERSION + ENDPOINT;
    httpVerb: HttpVerbType = "get";

    constructor() {
        super();
    }

    public async execute(): Promise<GetCurrentUserResData> {
        var res = await this.executeCommand();
        return new GetCurrentUserResData(res);
    }
}
